export default __webpack_public_path__ + "static/media/scroll-arrow.6875ec62.svg";